import angular from 'angular'
import './home.service'

angular.module('admin.home', ['admin.home.service']).controller('HomeAdminCtrl', HomeAdminCtrl)

/** @ngInject */
function HomeAdminCtrl($rootScope, $state, API, HomeAdminService, UserCache, VersionsService) {
  var vm = this
  vm.model = {}
  $rootScope.page = 'page'
  localStorage.removeItem('back_user_details')
  vm.sortType = 'id-asc'

  vm.openUrl = function() {
    if ($rootScope.customerService) {
      window.open(API.MOD_TOOLS, '_blank')
    } else {
      window.open(API.MOD_TOOLS, '_blank')
    }
  }

  VersionsService.list().then(
    function() {},
    function(err) {
      if (err === null) {
        UserCache.remove()
        $state.go('signin')
      }
    },
  )
}
